






























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import mixin from '../mixins/notifications-mixin'
import Notification from '@/types/Notification.interface'
import NotificationsList from '@/components/NotificationsList.vue'
export default Vue.extend({
    mixins: [mixin],
    components: { NotificationsList },
    data() {
        return {
            //  The currently active tab number
            active: 1
        }
    },
    computed: {
        ...mapGetters({
            unread: 'notificationsUnread',
            count: 'notificationsUnreadCount'
        }),
        notificationsUnreadGeneral(): Notification[] {
            return this.unread.filter(
                (x: Notification) =>
                    x.category != 'messages' &&
                    x.category != 'message' &&
                    x.data?.type !== 'commentMention'
            )
        },
        notificationsUnreadMentions(): Notification[] {
            return this.unread.filter(
                (x: Notification) => x.data?.type === 'commentMention'
            )
        },
        notificationsUnreadMessage(): Notification[] {
            return this.unread.filter(
                (x: Notification) => x.category == 'messages' || x.category == 'message'
            )
        }
    },
    methods: {
        //  Close the app dialog that hosts this component
        close(): void {
            //  Hide the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        //  Dismiss a single notification
        async dismiss(notification: Notification): Promise<void> {
            //  Create our payload (the 'read_at' attribute is updated server-side, so we only need to pass ids)
            const payload = [notification.id]

            //  Remove the notifications from the unread list (for instant UI response)
            this.$store.commit('notificationsUnreadRemove', [notification.id])

            //  Decrement the unread notifications count (for instant UI response)
            this.$store.commit('notificationsUnreadCountSet', this.count - 1)

            //  Send the changes to the server
            this.$store.dispatch('notificationsDismiss', payload)
        },
        //  Dismiss all unread notifications (message and general notifications)
        dismissAll(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Confirm Mark All As Read',
                text: 'Are you sure you want to mark all your notifications as read?',
                icon: 'mdi-alert-circle',
                callback: (result: boolean): void => {
                    //  If the user answered 'NO' do nothing
                    if (!result) return

                    //  Else, reset unread notifications (for instant UI response)
                    this.$store.commit('notificationsUnreadReset')

                    //  Send the request to the API
                    this.$store.dispatch('notificationsDismissAll')
                }
            })
        },
        //  Navigate to the notifications index
        goToIndex(): void {
            //  Close our menu
            this.close()

            //  Check if we are already on the notifications page
            const samePath = this.$route.path.includes('notifications')

            //  If we are, do nothing
            if (samePath) return

            //  else, navigate to the right tab
            this.$router.push(`/notifications`)
        },
        //  Define the font and background colors for our tabs
        tabStyle(num: number): object {
            //  Check if the tab is the active tab
            const isActive = this.active === num

            //  Select the tab style
            const style = {
                true: {
                    backgroundColor: this.$colors.mdPurple70,
                    color: 'white',
                    textDecoration: 'underline',
                    fontWeight: '700'
                },
                false: {
                    backgroundColor: 'white',
                    color: this.$colors.mdPurple,
                    textDecoration: 'none',
                    fontWeight: '400'
                }
            }[isActive.toString()]

            //  Return the style
            return style
        }
    }
})
